<ng-template #statusIcon />
